<template>
  <b-container fluid>
    <b-modal
      centered
      ref="modalInstance"
      header-bg-variant="primary"
      id="modalInstance"
      size="lg"
      :title="$t('Cancelar pedido')"
      :ok-title="$t('Aceptar')"
      @ok="submit"
      :ok-disabled="loadingSubstatus || loadingSubmitting || !substatus"
      :cancel-title="$t('Cancelar')"
      @cancel="hide"
      :cancel-disabled="loadingSubstatus || loadingSubmitting"
      o-close-on-backdrop="true"
    >
      <moon-loader :loading="loadingSubstatus || loadingSubmitting" color="#000" size="35px" class="mb-3"></moon-loader>
      <b-row class="alert alert-danger" v-show="errorText !== ''"><i class="fa fa-exclamation-circle"></i>{{errorText}}</b-row>
      <b-col v-show="!loadingSubstatus && !loadingSubmitting" ref="cancelOrderForm">
        <b-form-group horizontal
          :label-cols="3"
          breakpoint="md"
          label="Seleccione sub-estado:"
          label-for="cancelSubstatus">
          <b-form-select v-model="substatus" :options="substatusOptions" />
        </b-form-group>

      </b-col>
    </b-modal>
  </b-container>
</template>

<script>

import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
import { OrdersServiceMixim } from '@/mixims/OrdersServiceMixim.js'
import { SubStatusMixim } from '@/mixims/SubStatusMixim.js'

export default {
  name: 'cancel-order-modal',
  components: { MoonLoader },
  mixins: [OrdersServiceMixim, SubStatusMixim],
  props: ['order'],
  data () {
    return {
      loadingSubstatus: false,
      loadingSubmitting: false,
      substatusOptions: [],
      substatus: '',
      errorText: ''
    }
  },
  methods: {
    show() {
      this.loadingSubstatus = true
      this.$refs.modalInstance.show()
      this.getAllStatus({ status: 'canceled' }).then(function (response) {
        this.substatusOptions = response.body.length > 0 ? response.body.map(item => ({ value: item.id, text: item.name })) : []
        this.loadingSubstatus = false
      },
      (error) => {
        this.errorText = error.body.message || this.$t('Error obteniendo el listado de estados')
        this.loadingSubstatus = false
      })
    },
    hide() {
      this.substatusOptions = []
      this.substatus = ''
      this.$refs.modalInstance.hide()
    },
    submit(event) {
      event.preventDefault()
      this.loadingSubmitting = true
      this.cancelOrder(this.order.id, this.substatus).then(
        () => {
          this.loadingSubmitting = false
          this.hide()
          this.$emit('onSuccess')
        },
        (error) => {
          this.loadingSubmitting = false
          this.errorText = error.body.message || this.$t('Error cancelando el pedido')
          this.$emit('onError')
        }
      )
    },
  }
}

</script>